































import Vue from 'vue'

export default Vue.extend({
  name: 'TermsDialog',

  props: {
    value: {
      type: Boolean,
    },
    terms: {
      type: String,
    },
    contestId: {
      type: String,
    },
    contestName: {
      type: String,
    },
    projectId: {
      type: String,
    },
    isActiveApplyContest: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    applyToContest: function () {
      this.$api
        .post('/contest_applications', {
          contest: this.contestId,
          project: this.projectId,
        })
        .then((response) => {
          this.$emit('isAppliedToContest', true)
          this.$store.dispatch(
            'alert/success',
            'Thank you for participation in the contest.'
          )
        })
        .catch(() =>
          this.$store.dispatch(
            'alert/error',
            'Problems with adding your project to the contest.'
          )
        )
        .finally(() => (this.$emit('input', false)))
    },
  },

  data: () => ({
    isTermsAccepted: false,
  }),
})
